import { ILoyaltyUnredeemOfferApiRequest} from '~api/interfaces/ILoyaltyCartAPI';

export const UnredeemOffers = (unredeemOffersParam: ILoyaltyUnredeemOfferApiRequest) => {

    const { unredeemOffers } = unredeemOffersParam;

    const unredeemOffersQuery = `
        mutation  {
            unredeemOffer (
                offerCode: "${unredeemOffers.offerCode}",
            )
            {
                id
                success
                errorDetail
                userOfferCode
                userOfferRemovedMessage
            }
        }
    `;

    return unredeemOffersQuery;
};